module.exports = __webpack_public_path__ + "static/media/icon-plus-orange.fb9bf7d8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icon-plus-orange.svg
 ** module id = 1618
 ** module chunks = 0
 **/